import { WindAndWeatherCard } from "./WindAndWeatherCard";
export default WindAndWeatherCard;
